export const RouteName = {
  INFOGRAPHIC: "/infographic",
  LOGIN: "/login",
  PHC_PAGE: "/infographic/phc",
  MONITORING: "/monitoring",
  ASSESSORS_MAP: "/monitoring/assessors-map"
};
